import { ApiClientRoleKey } from 'hooks/internalApi';

import type { Option } from '@fragment/ui/src/components/Dropdown/Dropdown';

export const apiClientRoleOptions: Option[] = [
  { value: ApiClientRoleKey.WorkspaceReader, label: 'Reader' },
  { value: ApiClientRoleKey.WorkspaceAdmin, label: 'Admin' },
];
